export const BASE_URL = "https://mna-cars-warehouse-server.onrender.com/api/v1";
// export const BASE_URL = "http://localhost:5000/api/v1";
